import { apiInstance } from '../apiInstance';
import { protectedResources } from '../../msalAuthConfig';

const headers = {
    'Content-Type': 'application/json',
};

const logErrorApi = {
    logErrorToServer: async (error, errorInfo = null) => {
        try {
            await apiInstance({
                method: 'POST',
                url: `${protectedResources.apiLogClientError.endpoint}`,
                headers,
                data: {
                    message: error?.toString(),
                    stack: error?.stack || errorInfo?.componentStack || '',
                    time: new Date().toISOString(),
                    userAgent: navigator.userAgent,
                    url: window.location.href,
                },
            });
        } catch (e) {
            // Fallback: log to console if server logging fails
            // eslint-disable-next-line no-console
            console.error('Failed to log error to server', e);
        }
    },
};

export default logErrorApi;
